module.exports = __webpack_public_path__ + "static/img/3c.3148ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente-en/3c.png
// module id = 2QV4
// module chunks = 0